import { css } from "@emotion/react";

export const root = css`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 380px;
  gap: 24px;
  align-items: start;
  padding: 24px 0 40px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

export const main = css`
  min-width: 0;
  display: grid;
  gap: 18px;
`;

export const right = css`
  width: 100%;
  position: sticky;
  top: 24px;

  & > section,
  & > div {
    border-radius: 22px;
    box-shadow: 0 14px 34px rgba(15, 23, 42, 0.06);
  }

  @media (max-width: 1200px) {
    position: static;
  }
`;

export const imageCell = css`
  height: 40px;
  width: 56px;
  object-fit: cover;
  border-radius: 10px;
`;